<div class="aui-message aui-message-{{ type }} {{ classNames }}">
  <p class="title">
    <strong>{{ title }}</strong>
  </p>
  <p>
    <ng-content></ng-content>
  </p>
</div>
